import * as yup from 'yup';
import {ApiCall} from "../services/ApiCall";
import {push} from "svelte-spa-router";

const requiredMessage: string = 'Ce champ est obligatoire et doit être rempli.';
const maxMessage: string = 'Cette information doit faire moins de 191 caractères.'
const passwordMessage: string = 'Votre mot de passe doit être compris entre 6 à 20 caractères minimum et doit contenir au moins une lettre majuscule, une lettre minuscule et un chiffre.';

export const userSchema = yup.object().shape({
    gestionnaire_id: yup.string().nullable(),
    civility: yup.string().required(requiredMessage)
        .matches(/(Mr|Mme)/, 'Veuillez choisir entre Mr ou Mme.'),
    first_name: yup.string().nullable()
        .required(requiredMessage)
        .max(191, maxMessage),
    last_name: yup.string().nullable()
        .required(requiredMessage)
        .max(191, maxMessage),
    email: yup.string().nullable()
        .required(requiredMessage)
        .email('Veuillez ressaisir une adresse email valide.')
        .max(191, maxMessage)
        .test(
            'is-unique',
            'Une demande de création de compte ou un compte existant possède cette adresse email. Veuillez en changer.',
            async function (value) {

                let emailTest = false;

                // We join to the call the value of gestionnaire_id to know if it's an edition or a creation request
                // Because if it's an edition we need to accept if one mail address is found in the database because it's this user
                // If one mail adress is found when withClientInput is set to false (creation), we ask him to change the email address because an account already exist with.
                const apiCall = new ApiCall();
                try {
                    const content = await apiCall.postRequest('applicateur/check_email', {email: value, gestionnaire_id: this.parent.gestionnaire_id});
                    emailTest = content.data.email_test;
                }
                catch (e) {
                    push('/erreur500')
                }

                return emailTest;
            }),
    phone: yup.string().nullable()
        .when('phone', {
            is: (value: string) => value?.length,
            then: yup.string()
                .min(10, 'Le numéro de téléphone doit contenir au moins 10 caractères.')
                .max(12, 'Le numéro de téléphone doit contenir moins de 12 caractères.')
        }),
    mobile: yup.string().nullable()
        .when('mobile', {
            is: (value: string) => value?.length,
            then: yup.string()
                .min(10, 'Le numéro de téléphone doit contenir au moins 10 caractères.')
                .max(12, 'Le numéro de téléphone doit contenir moins de 12 caractères.')
        })
        .when(['phone','mobile'], {
            is: (phone: string|null, mobile: string|null) =>mobile?.length == 0 && phone?.length == 0 || mobile == null && phone == null,
            then: yup.string().nullable().required('Vous devez fournir un numéro de téléphone au minimum, que ce soit mobile ou fixe.')
        }),
    fax: yup.string().nullable()
        .notRequired()
        .min(10, 'Le numéro de fax doit contenir au moins 10 caractères.')
        .max(12, 'Le numéro de fax doit contenir moins de 12 caractères.'),
    password: yup.string().nullable()
        .when('withClientInput',{
            is: true,
            then: yup.string().nullable()
                .required(requiredMessage)
                .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/, passwordMessage)
        })
        .when('withClientInput', {
            is: false,
            then: yup.string().notRequired()
                .when('password',{
                    is: (value: string) => value?.length,
                    then: yup.string().matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/, passwordMessage)
                })
        }),
    passwordConfirmation: yup.string()
        .when('withClientInput',{
            is: true,
            then: yup.string().nullable().test(
                'is-egal',
                'Les mots de passes ne correspondent pas.',
                function (value) {
                    return this.parent.password === value
                })
        })
        .when('withClientInput',{
            is: false,
            then: yup.string().notRequired().test(
                'is-egal',
                'Les mots de passes ne correspondent pas.',
                function (value) {
                    return this.parent.password === value
                })
        }),
    withClientInput: yup.boolean(),
    client: yup.string()
        .when('withClientInput',{
            is: true,
            then: yup.string().nullable()
                .required(requiredMessage)
                .max(191, maxMessage)
        })
}, [['password', 'password'], ['mobile', 'mobile'], ['phone', 'phone']]);